import { CIcon } from '~/icons/types'

export const ciGearboxManual: CIcon = {
  width: '40',
  height: '40',
  paths: [
    {
      d:
        'M34.456 2.003c-1.751.07-3.178 1.475-3.27 3.208a3.39 3.39 0 0 0 2.314 3.39v9.634a.666.666 0 0 1-.668.664h-11.73V8.609a3.405 3.405 0 0 0 2.314-3.39c-.091-1.741-1.526-3.146-3.27-3.216-1.948-.077-3.55 1.475-3.55 3.39 0 1.49.97 2.754 2.313 3.216v10.297H6.519V8.609a3.405 3.405 0 0 0 2.313-3.39c-.091-1.741-1.526-3.146-3.277-3.216A3.412 3.412 0 0 0 2.005 5.4c0 1.49.97 2.754 2.313 3.216V31.39a3.408 3.408 0 0 0-2.314 3.398c.092 1.74 1.526 3.138 3.27 3.208 1.948.077 3.551-1.475 3.551-3.39 0-1.49-.97-2.755-2.313-3.216V21.094h12.39v10.297a3.407 3.407 0 0 0-2.314 3.398c.092 1.74 1.519 3.138 3.27 3.208 1.948.077 3.551-1.475 3.551-3.39 0-1.49-.97-2.755-2.313-3.216V21.094h12.58a2.005 2.005 0 0 0 2.01-2V8.61A3.404 3.404 0 0 0 38 5.393c.007-1.915-1.603-3.467-3.544-3.39Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'gearbox-manual',
  type: 'regular'
}
